
// ----------------------------------------------------------------------
// <copyright file="Izenda.TreeViewItemList.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = require('react');
  var ObservablePropTypes = require('mobx-react').propTypes;
  var observer = require('mobx-react').observer;
  var VirtualList = require('../Izenda.VirtualList');
  var TreeViewItem = require('./Izenda.TreeViewItem');
  var classnames = require('classnames');

  var TreeViewItemList = React.createClass({
    propTypes : {
      treeStore : ObservablePropTypes.observableObject
    },
    componentWillMount : function () {
      var props = this.props;
      var treeStore = props.treeStore;
      treeStore.setNodes(props.flattenNodes);
      //this.toggleCollapsible = treeStore.toggleCollapsibleOfNode.bind(treeStore);
    },
    componentWillReceiveProps : function (nextProps) {
      var treeStore = nextProps.treeStore;
      treeStore.setNodes(nextProps.flattenNodes);
    },
    render : function () {
      var props = this.props;
      var treeStore = props.treeStore;
      var visibleNodes = treeStore.visibleNodeList;
      var hasItems = visibleNodes.length;
      var className = classnames('izenda-TreeViewItemList', props.className);
      return hasItems
        ? (
            <VirtualList
              className={className}
              dataSource={visibleNodes}
              getItemKey={this.getKey}
              renderItem={this.renderItem} />
          )
        : null;
    },
    renderItem : function (node) {
      var props = this.props;
      var renderNode = props.renderNode;
      var treeStore = props.treeStore;
      var expanded = treeStore.isExpanded(node);

      return (<TreeViewItem
                node={node}
                treeViewItemClassName={props.treeViewItemClassName}
                renderNode={renderNode}
                expanded={expanded}
                toggleCollapsible={treeStore.toggleCollapsibleOfNode.bind(treeStore)}/>);
    },
    getKey : function (node) {
      return node.key;
    }
  });

  module.exports = observer(TreeViewItemList);
}();



// WEBPACK FOOTER //
// ./ui/share/components/controls/TreeView/Izenda.TreeViewItemList.jsx